/**
 * Identité officielle d'Aoria — source unique de vérité.
 * Modifier ici se répercute dans le footer, les mentions légales, etc.
 */
export const ORG = {
    name: "AORIA",
    displayName: "Aoria",
    form: "Association déclarée régie par la loi du 1er juillet 1901",
    formShort: "Association déclarée loi 1901",
    siren: "993 013 549",
    address: {
        street: "19 rue de Wicardenne",
        zip: "62200",
        city: "Boulogne-sur-Mer",
        country: "France",
    },
    email: "contact@aoria.org",
    tagline: "Pour l'accessibilité cognitive à l'ère numérique.",
    mission:
        "Aoria est une association consacrée à l'accessibilité cognitive. Elle explore la manière dont les outils numériques et l'intelligence artificielle peuvent contribuer à réduire certains obstacles cognitifs et renforcer l'autonomie dans les études, le travail et la vie quotidienne.",
    publicationDirector: "La présidence d'Aoria",
    host: {
        name: "Netlify, Inc.",
        address: "44 Montgomery Street, Suite 300, San Francisco, CA 94104, USA",
        website: "https://www.netlify.com",
    },
};
